export const events = {
  edit: {
    start: 'START_EDITING_BLURB',
    stop: 'STOP_EDITING_BLURB',
    cancel: 'CANCEL_EDITING_BLURB'
  },
  set: {
    firstName: 'SET_BLURB_FIRST_NAME',
    middleName: 'SET_BLURB_MIDDLE_NAME',
    lastName: 'SET_BLURB_LAST_NAME',
    investorTitle: 'SET_BLURB_INVESTOR_TITLE',
    investorCompany: 'SET_BLURB_INVESTOR_COMPANY',
    investorCompanyWebsite: 'SET_BLURB_INVESTOR_COMPANY_WEBSITE',
    investorBuildingDetails: 'SET_BLURB_INVESTOR_BUILDING_DETAILS',
    investorStreetAddress: 'SET_BLURB_INVESTOR_STREET_ADDRESS',
    investorSuburb: 'SET_BLURB_INVESTOR_SUBURB',
    investorPostalCode: 'SET_BLURB_INVESTOR_POSTAL_CODE',
    investorCity: 'SET_BLURB_INVESTOR_CITY',
    latitudeStreetAddress: 'SET_LATITUDE',
    longitudeStreetAddress: 'SET_LONGITUDE',
    investorDescription: 'SET_BLURB_INVESTOR_DESCRIPTION'
  }
}

const { edit, set } = events
export const actions = {
  edit: {
    start: () => ({
      type: edit.start
    }),
    stop: () => ({
      type: edit.stop
    }),
    cancel: () => ({
      type: edit.cancel
    })
  },
  set: {
    firstName: (firstName) => ({
      type: set.firstName,
      firstName
    }),
    middleName: (middleName) => ({
      type: set.middleName,
      middleName
    }),
    lastName: (lastName) => ({
      type: set.lastName,
      lastName
    }),
    investorTitle: (title) => ({
      type: set.investorTitle,
      title
    }),
    investorCompany: (company) => ({
      type: set.investorCompany,
      company
    }),
    investorCompanyWebsite: (website) => ({
      type: set.investorCompanyWebsite,
      website
    }),
    investorBuildingDetails: (buildingDetails) => ({
      type: set.investorBuildingDetails,
      buildingDetails
    }),
    investorStreetAddress: (streetAddress) => ({
      type: set.investorStreetAddress,
      streetAddress
    }),
    investorSuburb: (suburb) => ({
      type: set.investorSuburb,
      suburb
    }),
    investorPostalCode: (postalCode) => ({
      type: set.investorPostalCode,
      postalCode
    }),
    investorCity: (city) => ({
      type: set.investorCity,
      city
    }),
    latitudeStreetAddress: (latitude) => ({
      type: set.latitudeStreetAddress,
      latitude
    }),
    longitudeStreetAddress: (longitude) => ({
      type: set.longitudeStreetAddress,
      longitude
    }),
    investorDescription: (adviserDescription) => ({
      type: set.investorDescription,
      adviserDescription
    })
  }
}
